import { DefaultsApi } from "../../client-identity";
import { useDefaultsAPI } from "../api/useDefaultsAPI";

export type Culture = {
  id: string;
  code: string;
  short_code: string;
  name: string;
};

type CulturesData = {
  cultures: Culture[];
};

const initialValue = { cultures: [] };

const handleRequest = async (api: DefaultsApi) => {
  const response = await api.defaultsSearchCultures({});

  return {
    cultures: response.list,
  };
};

export const useCultures = () => {
  return useDefaultsAPI<CulturesData>({
    initialValue,
    handleRequest,
  });
};
